

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MwcStringTemplateOutletDirective } from './string_template_outlet.directive';

@NgModule({
  imports: [CommonModule],
  exports: [MwcStringTemplateOutletDirective],
  declarations: [MwcStringTemplateOutletDirective]
})
export class MwcOutletModule {}
